import React from "react";
import styled from "styled-components";
import { ITheme } from "../Themes/ThemeTypes";
import { ThemeColorEnum, ThemeIconEnum, ThemeIconSizeEnum } from "../Themes/ThemeEnums";
import Icon from "../Icon/Icon";
import FontText from "../FontText/FontText";
import { FontSizeEnum, FontTypeEnum } from "../FontText/FontTextEnums";

const Wrapper = styled.div<{ theme: ITheme }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 48px 16px;
`;

interface EmptyStateProps {
  icon?: ThemeIconEnum;
  headline: string;
  supporting?: string;
  action?: React.ReactElement;
}

const EmptyState: React.FC<EmptyStateProps> = ({ icon, headline, supporting, action }) => (
  <Wrapper>
    {icon !== undefined && (
      <Icon
        icon={icon}
        color={ThemeColorEnum.ON_SURFACE_VARIANT}
        size={ThemeIconSizeEnum.EXTRA_EXTRA_LARGE}
      />
    )}
    <FontText
      text={headline}
      $color={ThemeColorEnum.ON_SURFACE}
      $fontType={FontTypeEnum.TITLE}
      $fontSize={FontSizeEnum.MEDIUM}
    />
    {supporting && (
      <FontText
        text={supporting}
        $color={ThemeColorEnum.ON_SURFACE_VARIANT}
        $fontType={FontTypeEnum.BODY}
        $fontSize={FontSizeEnum.MEDIUM}
      />
    )}
    {action}
  </Wrapper>
);

export default EmptyState;
